/**
 * The hub's item cards (PHASE3 T3.1): name, family and a one-line effect for each item id in
 * `items.json`. Runkr items come from boxes in the race, so the row is information only (D-048).
 * No numbers here: they live in `packages/config` and change with balance passes.
 */
export type ItemFamily = 'self' | 'trap' | 'projectile'

export interface ItemInfo {
  id: string
  name: string
  family: ItemFamily
  /** Under `public/assets/`. */
  icon: string
  effect: string
}

export const ITEM_INFO: readonly ItemInfo[] = [
  {
    id: 'boost_jet',
    name: 'Boost Jet',
    family: 'self',
    icon: 'items/icon_boost.png',
    effect: 'A short burst of speed that also rolls over slow ground.',
  },
  {
    id: 'shield_bubble',
    name: 'Shield Bubble',
    family: 'self',
    icon: 'items/icon_shield.png',
    effect: 'Wraps you in a bubble that soaks up the next hit.',
  },
  {
    id: 'trip_wire',
    name: 'Trip Wire',
    family: 'trap',
    icon: 'items/icon_trap.png',
    effect: 'Drops behind you. The next racer to touch it tumbles, so jump over it.',
  },
  {
    id: 'spike_ball',
    name: 'Spike Ball',
    family: 'projectile',
    icon: 'items/icon_roller.png',
    effect: 'Rolls ahead along the ground and knocks over the first racer it meets.',
  },
  {
    id: 'homing_drone',
    name: 'Homing Drone',
    family: 'projectile',
    icon: 'items/icon_homing.png',
    effect: 'Chases the racer just ahead of you. Jump at the last moment to dodge one.',
  },
  {
    id: 'oil_slick',
    name: 'Oil Slick',
    family: 'trap',
    icon: 'items/icon_oil_slick.webp',
    effect: 'Spills behind you. Whoever runs onto it skids along, slow and helpless, so jump it.',
  },
  {
    id: 'leader_missile',
    name: 'Leader Missile',
    family: 'projectile',
    icon: 'items/icon_leader_missile.webp',
    effect: 'Only for last place: flies to whoever leads and knocks over everyone near them.',
  },
  {
    id: 'magnet',
    name: 'Magnet',
    family: 'self',
    icon: 'items/icon_magnet.webp',
    effect: 'For a few seconds, nearby shards and item boxes fly to you.',
  },
]

export const FAMILY_TEXT: Record<ItemFamily, string> = {
  self: 'Helps you',
  trap: 'Trap',
  projectile: 'Thrown',
}
